<div class="page-name">
  <h3>{{ 'account-preview.page-name' | translate }}</h3>
</div>

<div class="profile-navigation">
  <div class="item active">
    <p class="subtitle-14">{{ "account-navigation.account" |  translate }}</p>
  </div>

  <div class="item" (click)="navigateContactUs()">
    <p class="subtitle-14">{{ "account-navigation.contact-us" |  translate }}</p>
  </div>

  <div class="item" (click)="navigateVouchers()">
    <p class="subtitle-14">{{ "account-navigation.vouchers" |  translate }}</p>
  </div>
</div>

@if (cognitoUser$ | async; as cognitoAuthenticatedUser) {
  @if (user) {
    <div class="card">
      <div class="card-header">
        <div class="top-row">
          <span class="title tag-12">{{ 'account-preview.pet-parent.title'| translate }}</span>
          <button class="button link text-button-12"
            (click)="navigateEdit()">{{ 'account-preview.pet-parent.edit'| translate }}
          </button>
        </div>
        <div class="parent-main-info">
          <div class="parent-picture">
            @if (avatar) {
              <img class="image" [src]="avatar" alt="avatar">
            }
            @if (!avatar) {
              <img class="no-image" src="assets/parent_icon_placeholder.png" alt="no-image"/>
            }
          </div>
          <div class="info">
            <p class="name">{{ user.firstName }} {{ user.lastName }}</p>
            <p class="email body-14">{{ cognitoAuthenticatedUser.email }}</p>
          </div>
        </div>
      </div>
      <div class="card-body-container">
        <div class="card-body rows-container">
          <div class="rows">
            <div class="row">
              <div class="title">
                <p class="body-14">{{ 'account-preview.pet-parent.phone'| translate }}</p>
              </div>
              <div class="value">
                <p class="subtitle-14">{{ user.phoneNumber }}</p>
              </div>
            </div>
            <div class="row">
              <div class="title">
                <p class="body-14">{{ 'account-preview.pet-parent.location'| translate }}</p>
              </div>
              <div class="value">
                <p
                class="subtitle-14">{{ composedUserAddress }}</p>
              </div>
            </div>
            <div class="row">
              <div class="title">
                <p class="body-14">{{ 'account-preview.pet-parent.date-of-birth'| translate }}</p>
              </div>
              <div class="value">
                <p class="subtitle-14">{{ user.parent_birthdate | date:"dd.MM.yyyy" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="top-row">
          <span class="title tag-12">{{ 'account-preview.security.title'| translate }}</span>
        </div>
      </div>
      <div class="card-body">
        <div class="card-item password">
          <div class="item-body">
            <p class="name body-12">{{ 'account-preview.security.password' | translate }}</p>
            <p class="value subtitle-14">•••••••••••••</p>
          </div>
          <button class="button link text-button-12"
            (click)="navigateChangePassword()">{{ 'account-preview.security.edit' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="top-row">
          <span class="title tag-12">{{ 'account-preview.connected-accounts.title'| translate }}</span>
        </div>
      </div>
      <div class="card-body">
        <div class="card-item google">
          <div class="item-body">
            <div class="provider">
              <mat-icon svgIcon="google"></mat-icon>
              <p class="name subtitle-14">{{ 'account-preview.connected-accounts.google' | translate }}</p>
            </div>
            @if (isGoogleLinked) {
              <p class="value body-12">{{ user.googleLoginEmail || cognitoAuthenticatedUser.email }}</p>
              @if (user.googleLinkedAt) {
                <p class="value body-12">
                  {{ 'account-preview.connected-accounts.connected-since' | translate: { date: (user.googleLinkedAt | date:'dd.MM.yyyy') } }}
                </p>
              }
            } @else {
              <p class="value body-12">{{ 'account-preview.connected-accounts.description' | translate }}</p>
            }
          </div>
          @if (!isGoogleLinked) {
            <button class="button link text-button-12"
              [disabled]="googleLinkAction !== 'idle'"
              (click)="connectGoogle()">
              {{ (googleLinkAction === 'connecting'
              ? 'account-preview.connected-accounts.connecting'
              : 'account-preview.connected-accounts.connect') | translate }}
            </button>
          }
          @if (isGoogleLinked) {
            <button class="button link text-button-12"
              [disabled]="googleLinkAction !== 'idle'"
              (click)="disconnectGoogle()">
              {{ (googleLinkAction === 'disconnecting'
              ? 'account-preview.connected-accounts.disconnecting'
              : 'account-preview.connected-accounts.disconnect') | translate }}
            </button>
          }
        </div>
      </div>
      @if (googleLinkMessage) {
        <p class="google-link-message body-12"
          [class.error]="googleLinkMessage.kind === 'error'">
          {{ googleLinkMessage.key | translate }}
        </p>
      }
    </div>
    <div class="card">
      <div class="card-header">
        <div class="top-row">
          <span class="title tag-12">{{ 'account-preview.bank-account.title'| translate }}</span>
        </div>
      </div>
      <div class="card-body">
        <div class="card-item iban">
          <div class="item-body">
            <p class="name body-12">{{ 'account-preview.bank-account.iban' | translate }}</p>
            @if (ibanLastFour) {
              <p class="value subtitle-14">•••• •••• •••• •••• •••• {{ ibanLastFour }}</p>
            }
            @if (!ibanLastFour) {
              <p class="value subtitle-14">{{ 'account-preview.bank-account.no-iban' | translate }}</p>
            }
          </div>
          <button class="button link text-button-12"
            (click)="navigateChangeIban()">{{ 'account-preview.bank-account.edit' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="top-row">
          <span class="title tag-12">{{ 'account-preview.language.title'| translate }}</span>
        </div>
      </div>
      <div class="card-body">
        <div class="lang-list">
          @for (lang of langs; track lang) {
            <button class="button small" [class.selected]="lang === currentLang"
              (click)="setLang(lang)">{{ ('account-preview.language.languages.' + lang) | translate }}
            </button>
          }
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="button primary" (click)="logout()">
        {{ 'account-preview.logout' | translate }}
      </button>
    </div>
    @if (isDev) {
      <div class="actions">
        <button class="button secondary" (click)="grantMeikoVoucher()">
          [DEV] Test: Grant Meiko Voucher
        </button>
        @if (grantVoucherStatus === 'success') {
          <p class="body-12" style="color: green; margin-top: 4px;">
            Voucher granted – open notifications panel.
          </p>
        }
        @if (grantVoucherStatus === 'error') {
          <p class="body-12" style="color: red; margin-top: 4px;">
            Request failed. Check console.
          </p>
        }
      </div>
    }
  }
}
